import { ClientStatus } from '@cognitivecredit/ui-utils'

export interface User {
  Session: null | object
  attributes: {
    sub: string
    email_verified: boolean
    'custom:migrated': string
    'custom:clientId': string
    name: string
    phone_number_verified: boolean
    phone_number: string
    given_name: string
    family_name: string
    email: string
    'custom:userId': string
  }
  authenticationFlowType: string
  client: {
    displayName: string
    endpoint: string
    hasInstruments: boolean
    loanTradingDesk: boolean
    status: ClientStatus
    trialDates: {
      trialDaysRemaining: null | string
      trialEndDate: null | string
      trialStartDate: null | string
    }
  }
  keyPrefix: string
  signInUserSession: {
    idToken: {
      jwtToken: string
      payload: {
        aud: string
        auth_time: number
        'cognito:groups': string[]
        'cognito:username': string
        'custom:clientId': string
        'custom:migrated': string
        'custom:userId': string
        email: string
        email_verified: boolean
        event_id: string
        exp: number
        family_name: string
        given_name: string
        iat: number
        iss: string
        jti: string
        name: string
        origin_jti: string
        phone_number: string
        phone_number_verified: boolean
        sub: string
        token_use: string
      }
    }
    refreshToken: {
      token: string
    }
    accessToken: {
      jwtToken: string
      payload: {
        auth_time: number
        client_id: string
        'cognito:groups': string[]
        event_id: string
        exp: number
        iat: number
        iss: string
        jti: string
        origin_jti: string
        scope: string
        sub: string
        token_use: string
        username: string
      }
    }
    clockDrift: number
  }
  username: string
}
export interface License {
  availableToMe: boolean
  description: string
  id: string
  name: string
}
export interface UserPreferences {
  id: string
  messagePreferences: {
    showFinancialHelp: boolean
    showRACUploadHelp: boolean
    showUpdateHelp: boolean
  }
  notifications: {
    dailyAll: boolean
    dailyFavourite: boolean
    newCoverage: boolean
    realtimeAll: boolean
    realtimeFavourite: boolean
    weeklyAll: boolean
    weeklyFavourite: boolean
  }
  sheetZoom: number
  timeZone: string
  watchlistOnly: boolean
}
export interface UserState {
  user: User
  watchList: string[]
  preferences: UserPreferences | undefined
  licenseList: License[] | null
  watchListOnly: boolean
  selectedUniverses: License[] | null
  survey: {
    showButton: boolean
    showPopup: boolean
  }
}

export default {
  user: undefined,
  watchList: [],
  preferences: undefined,
  licenseList: null,
  watchListOnly: false,
  selectedUniverses: null,
}
